export default "__VITE_ASSET__CqxvEC88__"